import { render, staticRenderFns } from "./SingleSliderComponent.vue?vue&type=template&id=c9ca39c6&lang=pug&"
import script from "./SingleSliderComponent.vue?vue&type=script&lang=js&"
export * from "./SingleSliderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports